<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Retur</span>
					<span class="pl-2 font-weight-bold">{{ detailRetur.por_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Detail Supplier</div>
							<div class="pt-1">{{detailRetur.supplier_name}}</div>
							<div class="pt-1">{{detailRetur.supplier_email}}</div>
							<div class="pt-1">{{detailRetur.supplier_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailRetur)}}</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Retur</div>
							<v-col class="pt-3 pb-2 px-0">
								<span class="rounded caption text-uppercase white--text text-center py-3 px-5 primary">
									{{detailRetur.por_status | toStatusReturWH}}
								</span>
							</v-col>
							<div class="text-subtitle-1 mt-2 font-weight-bold">Catatan</div>
							<v-col cols="12" class="mt-1 pa-0">
								{{ detailRetur.por_note ? detailRetur.por_note : '-' }}
							</v-col>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailRetur.por_detail" hide-default-footer>
							<template v-slot:item.por_detail_quantity_requested="{ item }">
								<div>{{ item.por_detail_quantity_requested | toNumber }}</div>
							</template>
							<template v-slot:item.por_detail_quantity_approved="{ item }">
								<div>{{ item.por_detail_quantity_approved | toNumber }}</div>
							</template>
							<template v-slot:item.por_detail_quantity_delivered="{ item }">
								<div>{{ item.por_detail_quantity_delivered | toNumber }}</div>
							</template>
							<template v-slot:item.por_detail_quantity_transport="{ item }">
								<div>{{ item.por_detail_quantity_transport | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">status Retur</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailRetur.por_status_returned_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRetur.por_status == 'returned' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'returned' | toStatusReturWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRetur.por_status_returned_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRetur.por_status_processed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRetur.por_status == 'processed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'processed' | toStatusReturWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRetur.por_status_processed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRetur.por_status_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRetur.por_status == 'approved' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'approved' | toStatusReturWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRetur.por_status_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRetur.por_status_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRetur.por_status == 'rejected' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'rejected' | toStatusReturWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRetur.por_status_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRetur.por_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRetur.por_status == 'created' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusReturWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailRetur.por_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'por_detail_product_name', sortable: false},
			{ text: 'Jumlah Retur', value: 'por_detail_quantity_requested', sortable: false, align: 'center' },
			{ text: 'Jumlah Approve', value: 'por_detail_quantity_approved', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'por_detail_quantity_delivered', sortable: false, align: 'center' },
			{ text: 'Jumlah Dikirim', value: 'por_detail_quantity_transport', sortable: false, align: 'center' },
			],
		}
	},
	computed:{
		...mapState('retur', ['detailRetur']),
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.supplier_address)
				data.push(value.supplier_address)
			if (value.supplier_subdistrict_name)
				data.push(value.supplier_subdistrict_name)
			if (value.supplier_city_name)
				data.push(value.supplier_city_name)
			if (value.supplier_province_name)
				data.push(value.supplier_province_name)
			return data.join(', ')
		}
	}
}
</script>